<template>
  <div class="main">
    <a-form id="formLogin" class="user-layout-login" ref="formLogin" :form="form" @submit="handleSubmit">
      <div class="user-input" @keydown.tab.prevent>
        <div
          class="interior"
          :style="{
            transform: isInteriorUser ? 'translateX(0)' : 'translateX(-100%)',
            opacity: isInteriorUser ? 1 : 0
          }"
        >
          <a-form-item label="" has-feedback :colon="false">
            <a-input
              size="large"
              type="text"
              allowClear
              :placeholder="$t('login.inputAccount')"
              v-decorator="[
                'interiorUsername',
                {
                  rules: [{ required: true, message: $t('login.inputAccount') }, { validator: handleUsernameOrEmail }],
                  validateTrigger: 'change'
                }
              ]"
            >
              <img src="@/assets/icons/icon_zhanghao.png" slot="prefix" alt="" srcset="" />
            </a-input>
          </a-form-item>
          <a-form-item label="" has-feedback :colon="false">
            <a-input
              size="large"
              allowClear
              :placeholder="$t('login.inputPassword')"
              :type="!passwordFlag ? 'password' : 'text'"
              v-decorator="[
                'interiorPassword',
                { rules: [{ required: true, message: $t('login.inputPassword') }], validateTrigger: 'blur' }
              ]"
            >
              <img src="@/assets/icons/icon_mima.png" slot="prefix" alt="" srcset="" />
              <img
                @click="passwordFlag = true"
                v-if="!passwordFlag"
                src="@/assets/icons/icon_bi.png"
                slot="suffix"
                alt=""
              />
              <img @click="passwordFlag = false" v-else src="@/assets/icons/icon_kai.png" slot="suffix" alt="" />
            </a-input>
          </a-form-item>
        </div>
        <div
          class="external"
          :style="{
            transform: !isInteriorUser ? 'translateX(0)' : 'translateX(100%)',
            opacity: !isInteriorUser ? 1 : 0
          }"
        >
          <a-form-item label="" has-feedback :colon="false">
            <a-input
              size="large"
              type="text"
              allowClear
              :placeholder="$t('login.inputExternalAccount')"
              v-decorator="[
                'username',
                {
                  rules: [{ required: true, message: $t('login.inputExternalAccount') }, { validator: handleUsernameOrEmail }],
                  validateTrigger: 'change'
                }
              ]"
            >
              <img src="@/assets/icons/icon_zhanghao.png" slot="prefix" alt="" srcset="" />
            </a-input>
          </a-form-item>
          <a-form-item label="" has-feedback :colon="false">
            <a-input
              size="large"
              allowClear
              :placeholder="$t('login.inputExternalPassword')"
              :type="!passwordFlag ? 'password' : 'text'"
              v-decorator="[
                'password',
                { rules: [{ required: true, message: $t('login.inputExternalPassword') }], validateTrigger: 'blur' }
              ]"
            >
              <img src="@/assets/icons/icon_mima.png" slot="prefix" alt="" srcset="" />
              <img
                @click="passwordFlag = true"
                v-if="!passwordFlag"
                src="@/assets/icons/icon_bi.png"
                slot="suffix"
                alt=""
              />
              <img @click="passwordFlag = false" v-else src="@/assets/icons/icon_kai.png" slot="suffix" alt="" />
            </a-input>
          </a-form-item>
        </div>
      </div>
      <!-- <a-form-item v-show="codeStep >= 3">
        <a-row>
          <a-col :span="14">
            <a-input
              size="large"
              type="text"
              placeholder="验证码"
              :max-length="5"
              v-decorator="['captcha', {rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur'}]">
              <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }"/>
            </a-input>
          </a-col>
          <a-col :span="8" class="cp fr">
            <img
              :span="8"
              @click="setCode"
              style="width: 100px;height: 40px;cursor: pointer;display: block;"
              :src="codeSrc"
              alt="验证码"/>
          </a-col>
        </a-row>
      </a-form-item> -->
      <a-form-item class="login-button">
        <a-button size="large" type="primary" htmlType="submit" :loading="state.loginBtn" :disabled="state.loginBtn"
          >{{ $t('login.login') }}</a-button
        >
      </a-form-item>

      <!-- <div class="user-login-other">
        <span>其他登录方式</span>
        <a>
          <a-icon class="item-icon" type="alipay-circle"></a-icon>
        </a>
        <a>
          <a-icon class="item-icon" type="taobao-circle"></a-icon>
        </a>
        <a>
          <a-icon class="item-icon" type="weibo-circle"></a-icon>
        </a>
        <router-link class="register" :to="{ name: 'register' }">注册账户</router-link>
      </div> -->
    </a-form>
    <two-step-captcha
      v-if="requiredTwoStepCaptcha"
      :visible="stepCaptchaVisible"
      @success="stepCaptchaSuccess"
      @cancel="stepCaptchaCancel"
    ></two-step-captcha>
  </div>
</template>

<script>
import md5 from 'md5'
import cookie from 'js-cookie'
import storage from 'store'
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import { professionMap } from '@/api/lesson'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import TipModal from '@/components/tipModal/index.vue'
import TwoStepCaptcha from '@/components/tools/TwoStepCaptcha'
import { getSmsCaptcha, adminLogin, userApi, schoolPermission, loginDing } from '@/api/login'
import { columnStatus } from '@/api/admin'

export default {
  components: {
    TipModal,
    TwoStepCaptcha
  },
  data() {
    return {
      currentLang: 'zh-CN',
      passwordFlag: false,
      customActiveKey: 'tab1',
      loginBtn: false,
      isLoginError: false,
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      form: this.$form.createForm(this),
      state: {
        time: 60,
        loginBtn: false,
        // login type: 0 email, 1 username, 2 telephone
        loginType: 0,
        smsSendBtn: false
      },
      codeStep: cookie.get('codeStep') || 0,
      codeSrc: '',
      isInteriorUser: true
    }
  },
  created() {
    // get2step({ })
    //   .then(res => {
    //     this.requiredTwoStepCaptcha = res.result.stepCode
    //   })
    //   .catch(() => {
    //     this.requiredTwoStepCaptcha = false
    //   })
    // this.requiredTwoStepCaptcha = true
    this.currentLang = this.$i18n.locale
  },
  mounted() {
    if (this.$route.query.authCode) {
      loginDing({
        // app_key: this.$route.query.state,
        code: this.$route.query.authCode
      }).then(res => {
        this.loginSuccess(res)
      })
    }
  },
  methods: {
    dingDingLogin() {
      if (process.env.NODE_ENV === 'development') {
        window.location.href =
          'https://login.dingtalk.com/oauth2/auth?redirect_uri=http://pt.qa.growlib.com/user/login&response_type=code&state=prolib &client_id=dinglwjn0yqfodxkminw&scope=openid &prompt=consent'
      } else {
        window.location.href = `https://login.dingtalk.com/oauth2/auth?redirect_uri=${window.location.origin}/user/login&response_type=code&state=prolib &client_id=dinglwjn0yqfodxkminw&scope=openid &prompt=consent`
      }
    },
    async setCode() {
      this.codeSrc = userApi.codeSrc + `?${Date.now()}`
    },
    ...mapActions(['Login', 'Logout']),
    // handler
    handleUsernameOrEmail(rule, value, callback) {
      const { state } = this
      const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
      if (regex.test(value)) {
        state.loginType = 0
      } else {
        state.loginType = 1
      }
      callback()
    },
    handleTabClick(key) {
      this.customActiveKey = key
      // this.form.resetFields()
    },
    handleSubmit(e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state
      } = this

      state.loginBtn = true

      // 根据用户类型动态设置校验字段
      const validateFieldsKey = this.isInteriorUser
        ? ['interiorUsername', 'interiorPassword']
        : ['username', 'password']

      validateFields(validateFieldsKey, { force: true }, (err, values) => {
        if (!err) {
          if (this.codeStep >= 3) {
            this.form.validateFields(['captcha'], { force: true })
            const captcha = this.form.getFieldValue('captcha')
            if (!captcha) {
              state.loginBtn = false
            } else {
              this.goLogin(values)
            }
          } else {
            this.goLogin(values)
          }
        } else {
          setTimeout(() => {
            state.loginBtn = false
          }, 600)
        }
      })
    },
    goLogin(values) {
      const { state } = this
      const loginParams = { ...values }

      // 根据用户类型获取正确的用户名和密码字段
      const usernameField = this.isInteriorUser ? 'interiorUsername' : 'username'
      const passwordField = this.isInteriorUser ? 'interiorPassword' : 'password'

      loginParams.password = md5(values[passwordField])
      loginParams.username = values[usernameField]
      loginParams.captcha = this.form.getFieldValue('captcha')
      loginParams.loginType = this.isInteriorUser ? 1 : 2

      adminLogin(loginParams)
        .then(res => this.loginSuccess(res))
        .catch(res => {
          if (res.code !== 200) {
            // cookie.set('codeStep', ++this.codeStep)
          }

          state.loginBtn = false
        })
    },
    getCaptcha(e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state
      } = this

      validateFields(['mobile'], { force: true }, (err, values) => {
        if (!err) {
          state.smsSendBtn = true

          const interval = window.setInterval(() => {
            if (state.time-- <= 0) {
              state.time = 60
              state.smsSendBtn = false
              window.clearInterval(interval)
            }
          }, 1000)

          const hide = this.$message.loading(this.$t('login.sendingCaptcha'), 0)
          getSmsCaptcha({ mobile: values.mobile })
            .then(res => {
              setTimeout(hide, 2500)
              this.$notification['success']({
                message: this.$t('common.tip'),
                description: this.$t('login.captchaSuccess', { captcha: res.result.captcha }),
                duration: 8
              })
            })
            .catch(err => {
              setTimeout(hide, 1)
              clearInterval(interval)
              state.time = 60
              state.smsSendBtn = false
              this.requestFailed(err)
            })
        }
      })
    },
    stepCaptchaSuccess() {
      this.loginSuccess()
    },
    stepCaptchaCancel() {
      this.Logout().then(() => {
        this.loginBtn = false
        this.stepCaptchaVisible = false
      })
    },
    loginSuccess(res) {
      const user = {
        id: res.data.id,
        name: res.data.name,
        username: res.data.username,
        avatar: res.data.avatar,
        schoolName: res.data.schoolName,
        schoolId: res.data.schoolId
      }
      cookie.remove('codeStep')
      cookie.set('user_infor', user, {
        domain: '.' + window.location.hostname
      })
      cookie.set('user_type', res.data.roles, {
        domain: '.' + window.location.hostname
      })
      cookie.set(ACCESS_TOKEN, res.data.token, {
        domain: '.' + window.location.hostname
      })
      localStorage.token = res.data.token
      this.isLoginError = false
      this.getTreeData()
      this.getSchoolPermission(res.data.roles)
    },
    getSchoolPermission(roles) {
      schoolPermission().then(async res => {
        const permissionList = res.data.list
        const result = await columnStatus()
        const fromSite = this.$route.query.fromSite
        let stateVerify = true
        localStorage.permissionList = [...permissionList]
        localStorage.roles = JSON.stringify(roles)
        if (roles.length === 1 && roles[0] === 'teacher') {
          if (fromSite) {
            stateVerify = this.redirectVerify(fromSite, result.data)
          } else {
            this.$router.push({ path: '/' })
          }
          // cookie.set('loginType', 2)
        } else if (roles.length === 1 && roles[0] === 'student') {
          // cookie.set('loginType', 3)
          if (fromSite) {
            stateVerify = this.redirectVerify(fromSite, result.data)
          } else {
            // 学生账号之前逻辑
            // if (result.data.status === 1) {
            //   window.location.href = '//' + result.data.customDomainPrefix + '.' + window.location.hostname
            // } else {
            //   this.$message.error('用户不存在')
            // }

            // v1.5 登录新逻辑
            this.$router.push({ path: '/' })
          }
        } else {
          if (fromSite) {
            stateVerify = this.redirectVerify(fromSite, result.data)
          } else {
            const userType = JSON.parse(cookie.get('user_type')).join(',')
            this.$router.push({
              path: '/',
              query: {
                isAdmin: userType.includes('external') ? '' : '1'
              }
            })
          }
          // cookie.set('loginType', 1)
        }
        // 延迟 1 秒显示欢迎信息
        if (stateVerify) {
          setTimeout(() => {
            const hour = new Date().getHours()
            const timeKey = hour < 9 
              ? 'morning'
              : hour <= 11 
                ? 'forenoon' 
                : hour <= 13
                  ? 'noon'
                  : hour < 20
                    ? 'afternoon'
                    : 'evening'
                    
            this.$notification.success({
              message: this.$t('welcome.title'),
              description: this.$t('welcome.message', { 
                timeGreeting: this.getTimeGreeting(hour)
              })
            })
          }, 1000)
        }
      })
    },
    getTimeGreeting(hour) {
      if (!this.$i18n) return ''
      const timeKey = hour < 9 
        ? 'morning'
        : hour <= 11 
          ? 'forenoon' 
          : hour <= 13
            ? 'noon'
            : hour < 20
              ? 'afternoon'
              : 'evening'
      return this.$t(`timeGreeting.${timeKey}`)
    },
    async getTreeData() {
      const treeList = [
        { id: 1, value: 1, label: '中职', name: '中职', checkedId: { V1: 1 } },
        { id: 2, value: 2, label: '高职', name: '高职', checkedId: { V1: 2 } },
        { id: 3, value: 3, label: '本科', name: '本科', checkedId: { V1: 3 } }
      ]
      treeList.forEach(async (item, index) => {
        await professionMap({ type: item.id }).then(res => {
          treeList[index].children = res.data.profession.map(obj => {
            const data = Object.assign(obj, {
              value: obj.id,
              label: obj.name,
              checkedId: {
                V1: item.id,
                V2: Number(obj.id)
              }
            })
            data.sub.forEach(child => {
              return Object.assign(child, {
                value: child.id,
                label: child.name,
                children: [],
                checkedId: {
                  V1: item.id,
                  V2: Number(obj.id),
                  V3: Number(child.id)
                }
              })
            })
            return data
          })
        })
        localStorage.treeList = JSON.stringify(treeList)
      })
      this.$store.commit('SET_TreeList', treeList)
    },
    requestFailed(err) {
      this.isLoginError = true
      this.$notification['error']({
        message: this.$t('common.error'),
        description: ((err.response || {}).data || {}).message || this.$t('common.requestError'),
        duration: 4
      })
    },
    // 跳转校验
    redirectVerify(fromSite, userState) {
      if (userState.customDomainPrefix.toLowerCase() && fromSite.includes(userState.customDomainPrefix)) {
        window.location.href = fromSite
        return true
      } else {
        this.loginout()
        this.$message.error(this.$t('login.userNotExist'))
      }
      this.state.loginBtn = false
      return false
    },
    loginout() {
      cookie.remove(ACCESS_TOKEN)
      cookie.remove(ACCESS_TOKEN, {
        domain: '.' + location.hostname
      })
      cookie.remove('user_type')
      cookie.remove('user_type', {
        domain: '.' + location.hostname
      })
      cookie.remove('user_infor')
      cookie.remove('user_infor', {
        domain: '.' + location.hostname
      })
    },
    changeLang (type) {
      const nextLang = type
      this.currentLang = nextLang
      this.$i18n.locale = nextLang
      storage.set('lang', nextLang)
      window.location.reload()
    },
    switchUser() {
      this.isInteriorUser = !this.isInteriorUser
      // 重置表单校验状态
      this.$nextTick(() => {
        this.form.resetFields()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.user-layout-login {
  .login-button {
    width: 100%;
    margin-top: 40px !important;
    text-align: center;
    .ant-btn-primary {
      border: 0;
      padding: 0;
      width: 100%;
      height: 65px;
      color: #fff;
      font-size: 20px;
      box-shadow: none;
      border-radius: 40px;
      background-size: 100% 100%;
      background: linear-gradient(#feab64, #fc7536);
    }
  }
  // 其它登录方式
  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
  }
  .switch-user {
    float: right;
    // margin-top: 10px;
    padding-right: 32px;
    &:hover {
      color: #feab64;
      cursor: pointer;
    }
  }
  .user-input {
    display: flex;
    justify-content: flex-start;
    position: relative;
    height: 175px;
    width: 100%;
    overflow: hidden;
    > div {
      width: 100%;
      position: absolute;
      transition: all 0.5s ease-in-out;
      margin-top: 5px;
      padding: 0 2px;
    }
    .external {
      transform: translateX(100%);
      opacity: 0;
    }
  }
}
.other-login {
  font-size: 12px;
  text-align: center;
}
.dingding-login {
  img {
    width: 48px;
    cursor: pointer;
    border-radius: 100%;
  }
  text-align: center;
}
.language-switch {
  text-align: right;
  margin-bottom: 16px;
  position: fixed;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  .line{
    width: 1px;
    height: 14px;
    background: #c2c2c2;
  }
  button{
    padding: 0 5px;
  }
}
/deep/ .select-language{
  span{
    color: #feab64;
  }
}
/deep/.ant-form{
  .ant-form-item{
    .has-feedback .ant-input-affix-wrapper .ant-input-suffix{
      padding-right: 0;
    }
    .ant-form-item-label {
      line-height: normal;
      margin-bottom: 13px;
      > label {
        font-size: 20px;
        font-weight: 500;
        color: #415172;
        padding-left: 20px;
      }
    }
    .ant-form-item-required::before {
      display: none;
    }
    .ant-form-explain {
      margin-top: 4px;
      margin-left: 5%;
    }
    .ant-form-item-control {
      line-height: 1em;
    }
    .ant-form-item-control.has-feedback.has-error {
      .ant-input {
        border-color: red;
      }
    }
    .ant-form-item-children-icon {
      display: none;
    }
    .ant-input-affix-wrapper {
      .ant-input-prefix {
        left: 38px;
        img {
          width: 20px;
        }
      }
      .ant-input-suffix {
        right: 40px;
        img {
          width: 23px;
          margin-left: 12px;
          cursor: pointer;
        }
      }
      .ant-input {
        height: 60px;
        color: #000;
        padding: 0 70px;
        font-size: 18px;
        font-weight: 400;
        color: #000000;
        border-radius: 35px;
        background: #ffffff;
        border: 1px solid #e3e5e8;
      }
    }
  }
}

@media screen and(min-width: 1700px) and (max-width: 1900px) {
  .user-layout-login {
    .login-button {
      margin-top: 35px !important;
      .ant-btn-primary {
        // width: 257px;
        height: 72px;
        font-size: 18px;
      }
    }
  }
  // 其它登录方式
  .dingding-login {
    img {
      width: 42px;
    }
  }
  /deep/.ant-form {
    .ant-form-item {
      .ant-form-item-label {
        margin-bottom: 13px;
        > label {
          font-size: 20px;
          padding-left: 20px;
        }
      }
      .ant-input-affix-wrapper {
        .ant-input {
          height: 55px;
          &::placeholder {
            font-size: 15px;
          }
        }
        .ant-input-prefix {
          left: 37px;
          img {
            width: 20px;
          }
        }
        .ant-input-suffix {
          right: 33px;
          img {
            width: 25px;
            margin-left: 12px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
@media screen and(min-width: 1500px) and (max-width: 1700px) {
  .user-layout-login {
    .login-button {
      margin-top: 36px !important;
      .ant-btn-primary {
        // width: 217px;
        height: 62px;
        font-size: 16px;
      }
    }
  }
  // 其它登录方式
  .dingding-login {
    img {
      width: 38px;
    }
  }
  /deep/.ant-form {
    .ant-form-item {
      .ant-form-item-label {
        line-height: normal;
        margin-bottom: 13px;
        > label {
          font-size: 18px;
          font-weight: 540;
        }
      }
      .ant-input-affix-wrapper {
        .ant-input {
          height: 50px;
          &::placeholder {
            font-size: 15px;
          }
        }
        .ant-input-prefix {
          left: 36px;
          img {
            width: 17px;
          }
        }
        .ant-input-suffix {
          right: 33px;
          img {
            width: 20px;
            margin-left: 12px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1300px) and (max-width: 1500px) {
  .user-layout-login {
    .login-button {
      margin-top: 36px !important;
      .ant-btn-primary {
        // width: 217px;
        height: 62px;
        font-size: 16px;
      }
    }
  }
  // 其它登录方式
  .dingding-login {
    img {
      width: 38px;
    }
  }
  /deep/.ant-form {
    .ant-form-item {
      .ant-form-item-label {
        line-height: normal;
        margin-bottom: 13px;
        > label {
          font-size: 18px;
          font-weight: 540;
        }
      }
      .ant-input-affix-wrapper {
        .ant-input {
          height: 50px;
          &::placeholder {
            font-size: 15px;
          }
        }
        .ant-input-prefix {
          left: 36px;
          img {
            width: 17px;
          }
        }
        .ant-input-suffix {
          right: 33px;
          img {
            width: 20px;
            margin-left: 12px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1200px) and (max-width: 1300px) {
  .user-layout-login {
    .login-button {
      margin-top: 26px !important;
      .ant-btn-primary {
        // width: 180px;
        height: 52px;
        font-size: 14px;
      }
    }
  }
  // 其它登录方式
  .dingding-login {
    img {
      width: 30px;
    }
  }
  /deep/.ant-form {
    .ant-form-item {
      .ant-form-item-label {
        line-height: normal;
        margin-bottom: 13px;
        > label {
          font-size: 16px;
          font-weight: 540;
        }
      }
      .ant-input-affix-wrapper {
        .ant-input {
          height: 45px;
          &::placeholder {
            font-size: 13px;
          }
        }
        .ant-input-prefix {
          left: 36px;
          img {
            width: 15px;
          }
        }
        .ant-input-suffix {
          right: 33px;
          img {
            width: 18px;
            margin-left: 12px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .user-layout-login {
    .login-button {
      margin-top: 26px !important;
      .ant-btn-primary {
        // width: 180px;
        height: 52px;
        font-size: 14px;
      }
    }
  }
  // 其它登录方式
  .dingding-login {
    img {
      width: 30px;
    }
  }
  /deep/.ant-form {
    .ant-form-item {
      .ant-form-item-label {
        line-height: normal;
        margin-bottom: 13px;
        > label {
          font-size: 16px;
          font-weight: 540;
        }
      }
      .ant-input-affix-wrapper {
        .ant-input {
          height: 45px;
          &::placeholder {
            font-size: 13px;
          }
        }
        .ant-input-prefix {
          left: 36px;
          img {
            width: 15px;
          }
        }
        .ant-input-suffix {
          right: 33px;
          img {
            width: 18px;
            margin-left: 12px;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
  .language-list{
    padding: 20px 25px;
    width: 145px;
    height: 128px;
    background-image: url(~@/assets/img/language.png);
    background-size: 100% 100%;
    margin-top: -20px;
    > div{
      width: 100%;
      height: 100%;
      .list{
        height: 44px;
        width: 100%;
        padding: 0 4px;
        border-bottom: 1px solid #F4F4F4;
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 14px;
        color: rgba(111,111,111,0.9);
        line-height: 22px;
        text-align: left;
        cursor: pointer;
        img{
          width: 20px;
          height: 15px;
          margin-right: 8px;
        }
      }
    }
  }
</style>
